<template>
  <div class="page-container has-action">
    <van-nav-bar left-arrow fixed :title="detail.name" @click-left="goBack" :z-index="10"></van-nav-bar>

    <div class="detail">
      <!-- 第一部分 -->
      <div class="header fy">
        <!-- +++++++++++++++++++++++++++++++++++++++++++++++++++++++++ -->
        <!-- 改 倒计时 start -->
        <div class="top">
          <div class="top-son">
            <template v-if="sellout">
              <span class="title">{{
                detail.productType == 2 ? "委托倒计时：" : "募集倒计时："
              }}</span>
              <van-count-down class="title" :time="countDown" @finish="finish" format="DD天HH时mm分ss秒"></van-count-down>
            </template>
            <span v-else class="title">已售罄</span>
          </div>
        </div>
        <!-- 改 倒计时 end -->

        <!-- 改 期限/收益率 start -->
        <div class="center" :style="detail.productType == 4
          ? 'margin-left: 45px; margin-right: 45px'
          : ''
          ">
          <!-- 收益率 -->
          <div class="center-left">
            <div class="left-t">
              <template v-if="detail.ifStair">
                <b>{{ rateInterval.minRate }}</b>
                <span class="left-b">%</span>
                <span class="c">~</span>
                <b>{{ rateInterval.maxRate }}</b>
                <span class="left-b">%</span>
              </template>
              <template v-else>
                <b>{{ expectedRate }}</b>
                <span class="left-b">%</span>
                <template v-if="
                  detail.isNew &&
                  detail.greenhandRate &&
                  detail.greenhandRate > 0
                ">
                  <span class="c">+</span>
                  <b>{{ detail.greenhandRate }}</b>
                  <span class="left-b">%</span>
                </template>
              </template>
            </div>
            <div class="left-d">{{ detail.productType == 2 ? "预期年化折扣率" : detail.productType == 5 ? "年化折扣率" : "预期年化收益率"
              }}</div>
            <div class="left-d" style="color:#fff;opacity:1" v-if="detail.productType == 5">
              对应年化收益率
              <template v-if="detail.ifStair">
                <template v-if="rateInterval1.minRate != rateInterval1.maxRate">
                  <b style="color:#fff">{{ rateInterval1.minRate }}</b>
                  <span class="left-b" style="color:#fff">%</span>
                  <span class="c">~</span>
                  <b style="color:#fff">{{ rateInterval1.maxRate }}</b>
                  <span class="left-b" style="color:#fff">%</span>
                </template>
                <template v-else>
                  <b style="color:#fff">{{ rateInterval1.minRate }}</b>
                  <span class="left-b" style="color:#fff">%</span>
                </template>
              </template>
              <template v-else>
                <b style="color:#fff">{{ detail.pydExpectedRate }}</b>
                <span class="left-b" style="color:#fff">%</span>
              </template>
            </div>
            <div class="left">
              <van-tag plain class="down-l" color="#FC6B26">{{
                getRiskRating
              }}</van-tag>
            </div>
          </div>

          <!-- 投资期限 -->
          <div class="center-center" :style="detail.productType == 4 ? 'flex: 0.5' : ''">
            <template v-if="detail.productType != 4">
              <div class="center-t">
                <b>{{ detail.investDuration }}</b>
                <span class="left-b">天</span>
              </div>
              <div class="center-d">
                {{ detail.productType == 2 ? "期限" : detail.productType == 5 ? "剩余期限" : "投资期限" }}
              </div>
            </template>
            <div class="center-tag">
              <van-tag class="down-c" v-if="detail.attachLabel" plain color="#ff9900">{{ detail.attachLabel }}</van-tag>
              <!-- 空占位 -->
              <div class="down-c" v-else style="width: 64px; font-size: 0.26667rem">
                &nbsp;
              </div>
            </div>
          </div>

          <!-- 剩余额度 v-else-->
          <div class="center-right">
            <template v-if="detail.productType == 4">
              <div class="right-t">
                <b>{{ detail.investDuration }}</b>
                <span class="left-b">天</span>
              </div>
              <div class="right-d">
                {{ detail.productType == 2 ? "期限" : "投资期限" }}
              </div>
            </template>
            <template v-else>
              <div class="right-t">
                <b>{{
                  isSoldOut
                    ? "0"
                    : amountFormat(detail.raisedAmount - detail.currentRaise)
                }}</b>
                <span class="left-b">万</span>
              </div>
              <div class="right-d">{{ detail.productType == 5 ? "可拍额度" : "剩余额度" }}</div>
              <div class="right-d" style="color:#fff;opacity:1" v-if="detail.productType == 5">以实际竞拍页面为准</div>
            </template>
            <div class="right">
              <van-tag v-if="progressText" plain class="down-r" text-color="#7F5702"
                style="background-color: #fcd32b">{{
                  progressText }}</van-tag>
              <!-- 空占位 -->
              <div class="down-r" v-else style="width: 64px; font-size: 0.26667rem">
                &nbsp;
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 第二部分 -->
      <!-- 新 start -->
      <div v-if="detail.ifStair && detail.stairRate.amountOne" class="rule fy">
        <!-- title -->
        <div class="rule-box">
          <div class="rule-title">
            <span class="title-a">{{ detail.productType == 2 ? "折扣规则" : "收益规则" }}</span>
            <span class="title-b">{{
              detail.productType == 2
                ? "按单笔委托竞买额计算折扣"
                : "按单笔认购金额计算收益"
            }}</span>
          </div>
          <!-- main -->
          <table class="rule-main">
            <thead>
              <tr>
                <th>
                  {{ detail.productType == 2 ? "委托竞买额" : "投资总额" }}
                </th>
                <th>{{ detail.productType == 2 ? "预期年化折扣率" : detail.productType == 5 ? "年化折扣率" : "预期收益率" }}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  {{ amountFormat(detail.stairRate.amountOne) }}万(含) ~
                  {{ amountFormat(detail.stairRate.amountTwo) }}万
                </td>
                <td>
                  {{ detail.stairRate.rateOne }}%
                  <span v-if="detail.hasNewYearActivity && detail.activityDiscount">+
                    {{
                      parseFloat(detail.activityDiscount.rate).toFixed(2)
                    }}%</span>
                </td>
              </tr>
              <tr>
                <td>
                  {{ amountFormat(detail.stairRate.amountTwo) }}万(含)
                  <template v-if="detail.stairRate.amountThree">
                    ~
                    {{ amountFormat(detail.stairRate.amountThree) }}万</template>
                  <template v-else>以上</template>
                </td>
                <td>
                  {{ detail.stairRate.rateTwo }}%
                  <span v-if="detail.hasNewYearActivity && detail.activityDiscount">+
                    {{
                      parseFloat(detail.activityDiscount.rate).toFixed(2)
                    }}%</span>
                </td>
              </tr>
              <tr v-if="detail.stairRate.amountThree">
                <td>
                  {{ amountFormat(detail.stairRate.amountThree) }}万(含)
                  <template v-if="detail.stairRate.amountFour">
                    ~
                    {{ amountFormat(detail.stairRate.amountFour) }}万</template>
                  <template v-else>以上</template>
                </td>
                <td>
                  {{ detail.stairRate.rateThree }}%
                  <span v-if="detail.hasNewYearActivity && detail.activityDiscount">+
                    {{
                      parseFloat(detail.activityDiscount.rate).toFixed(2)
                    }}%</span>
                </td>
              </tr>
              <tr v-if="detail.stairRate.amountFour">
                <td>
                  {{ amountFormat(detail.stairRate.amountFour) }}万(含)
                  <template v-if="detail.stairRate.amountFive">
                    ~
                    {{ amountFormat(detail.stairRate.amountFive) }}万</template>
                  <template v-else>以上</template>
                </td>
                <td>
                  {{ detail.stairRate.rateFour }}%
                  <span v-if="detail.hasNewYearActivity && detail.activityDiscount">+
                    {{
                      parseFloat(detail.activityDiscount.rate).toFixed(2)
                    }}%</span>
                </td>
              </tr>
              <tr v-if="detail.stairRate.amountFive">
                <td>
                  {{ amountFormat(detail.stairRate.amountFive) }}万(含)
                  <template v-if="detail.stairRate.amountSix">
                    ~
                    {{ amountFormat(detail.stairRate.amountSix) }}万</template>
                  <template v-else>以上</template>
                </td>
                <td>
                  {{ detail.stairRate.rateFive }}%
                  <span v-if="detail.hasNewYearActivity && detail.activityDiscount">+
                    {{
                      parseFloat(detail.activityDiscount.rate).toFixed(2)
                    }}%</span>
                </td>
              </tr>
              <tr v-if="detail.stairRate.amountSix">
                <td>
                  {{ amountFormat(detail.stairRate.amountSix) }}万(含) 以上
                </td>
                <td>
                  {{ detail.stairRate.rateSix }}%
                  <span v-if="detail.hasNewYearActivity && detail.activityDiscount">+
                    {{
                      parseFloat(detail.activityDiscount.rate).toFixed(2)
                    }}%</span>
                </td>
              </tr>
            </tbody>
          </table>
          <!-- des -->
          <!-- <div class="rule-des"> -->
          <!-- <div class="des">
              说明：募集期内若多次认购将自动累计，以募集截止日累计认购总额计算最后收益。
            </div> -->
          <!-- </div> -->
        </div>
      </div>
      <!-- 新 end -->

      <!-- 第三部分 -->
      <!-- 新 time start -->
      <div class="time fy">
        <div class="time-box">
          <!-- top -->
          <div class="top">
            <div class="top-left">
              <div class="a">
                {{ detail.productType == 2 ? "委托截止日" : detail.productType == 5 ? "竞买截止日" : "募集截止日" }}
              </div>
              <div class="img">
                <img src="../../assets/img/detail/suo.png" alt />
              </div>
              <div class="b">
                {{ dateFormat(detail.endTime, "YYYY-MM-DD") }}
              </div>
            </div>
            <div class="r">
              <img src="../../assets/img/detail/right.png" alt />
            </div>
            <div v-if="detail.productType != 5" class="top-left">
              <div class="a">
                {{ detail.productType == 2 ? "预计成交日" : "收益起算日" }}
              </div>
              <div class="img">
                <img src="../../assets/img/detail/naozhong.png" alt />
              </div>
              <div class="b">
                {{ dateFormat(detail.valueDate, "YYYY-MM-DD") }}
              </div>
            </div>
            <div v-if="detail.productType != 5" class="r">
              <img src="../../assets/img/detail/right.png" alt />
            </div>
            <div class="top-left">
              <div class="a">
                {{ detail.productType == 2 ? "拍品到期日" : detail.productType == 5 ? "拍品到期日" : "收益到期日" }}
              </div>
              <div class="img">
                <img src="../../assets/img/detail/money.png" alt />
              </div>
              <div class="b">
                {{ dateFormat(detail.dueDate, "YYYY-MM-DD") }}
              </div>
            </div>
          </div>
          <!-- center -->
          <template v-for="(n, i) of ruleItemTitles">
            <div class="center" v-if="n.type == 2 && n.val" :key="'rule-' + i">
              <span class="left">{{ n.key }}</span>
              <span class="right">{{ n.val }}</span>
            </div>
          </template>
        </div>
      </div>
      <!-- 新 time end -->

      <!-- 新 nav start -->
      <!-- <div class="nav fy">
        <div class="nav-box">
          <div :class="{active:currentTab==1}" @click="changetabs(1)">
            <span>资产特点</span>
          </div>
          <div :class="{active:currentTab==2}" @click="changetabs(2)">
            <span>资产档案</span>
          </div>
          <div :class="{active:currentTab==3}" @click="changetabs(3)">
            <span>常见问答</span>
          </div>
        </div>
      </div>-->
      <!-- 新 nav end -->

      <!-- 新 trait start -->
      <div class="trait fy" v-if="characteristicArray.length > 0">
        <div id="title1">资产特点</div>
        <div class="trait-box">
          <template v-for="(n, i) of characteristicArray">
            <div v-if="n.type == 1" :key="i">
              <div class="box-title">{{ n.key }}</div>
              <div class="center">
                <div class="center-box">
                  <div v-for="(obj, idx) of n.subTitle" :key="idx">
                    <img src="../../assets/img/detail/dui.png" alt />
                    <span> {{ obj }}</span>
                  </div>
                </div>
              </div>
            </div>
            <img v-else-if="n.type == 3" :src="n.val" :key="i" style="width: 80%" />
            <video v-else-if="n.type == 4" :src="n.val" :key="i" controls="controls" playsinline="true"
              autoplay="autoplay" style="width: 100%"></video>
          </template>
        </div>
      </div>
      <!-- 新 trait end -->

      <!-- 新 file start -->
      <div class="file fy" v-if="detail.protocolList">
        <div id="title2" v-if="detail.protocolList.length > 0">交易文件</div>
        <div class="file-box">
          <template v-if="detail.productType == 2">
            <van-cell v-for="(n, i) of detail.protocolList" :key="'protocol-' + i" :title="n.name" :to="{
              name: 'agreement-trade',
              query: {
                title: n.name,
                pushType: 2,
                productId: productId,
                id: n.id,
                type: '1'
              }
            }" is-link />
            <!-- 拍品相关文件  -->
            <div v-if="
              detail.auctionContentFiles &&
              detail.auctionContentFiles.length > 0
            ">
              <van-cell v-for="(item, i) of detail.auctionContentFiles" :key="i" :title="item.name" :to="{
                name: 'agreement/pdfDetail',
                query: { item: { url: item.filePath } }
              }" is-link></van-cell>
            </div>
          </template>
          <template v-else>
            <van-cell v-for="(n, i) of detail.protocolList" :key="'protocol-' + i" :title="n.name" :to="{
              name: 'agreement',
              query: { productId: productId, id: n.id }
            }" is-link />
          </template>
        </div>
      </div>
      <!-- 资产档案  -->
      <div class="file fy" v-if="detail.assetFilesList">
        <div id="title2">资产档案</div>
        <div class="file-box">
          <van-cell v-for="(n, i) of detail.assetFilesList" :key="'assetFile-' + i" :title="n.title" :to="{
            name: 'agreement/pdfDetail',
            query: { item: n }
          }" is-link />
        </div>
      </div>
      <!-- 新 problem start -->
      <div class="problem fy">
        <div id="title3">常见问题</div>

        <div class="problem-box">
          <van-collapse v-model="activeName" accordion>
            <template v-if="detail.qalist">
              <van-collapse-item v-for="(n, i) of detail.qalist" :name="i" :key="`qa-${i}`">
                <template #title>
                  <div class="first">
                    <img src="../../assets/img/detail/wenhao.png" alt />
                    {{ n.question }}
                  </div>
                </template>
                <div class="text">{{ n.answer }}</div>
              </van-collapse-item>
            </template>
            <template v-else>
              <van-collapse-item name="0">
                <template #title>
                  <div class="first">
                    <img src="../../assets/img/detail/wenhao.png" alt />
                    “{{ detail.typeName }}”资产转让系列投资人的收益方式是什么？
                  </div>
                </template>
                <div class="text">
                  到期一次性兑付，“{{
                    detail.typeName
                  }}”资产转让系列在转让到期日由转让/回购方进行溢价回购，相关投资本金和收益在不晚于资产转让到期日后三个工作日内兑付投资人。
                </div>
              </van-collapse-item>
              <van-collapse-item name="1">
                <template #title>
                  <div class="first">
                    <img src="../../assets/img/detail/wenhao.png" alt />
                    可以要求回购方提前回购吗？
                  </div>
                </template>
                <div class="text">
                  在投资人受让资产收益起算日起，至资产转让到期日止，投资人不得要求提前提取受让资金。
                </div>
              </van-collapse-item>
              <van-collapse-item name="2">
                <template #title>
                  <div class="first">
                    <img src="../../assets/img/detail/wenhao.png" alt />
                    “{{
                      detail.typeName
                    }}”资产转让系列在投资开放期内是否可以撤销投资？
                  </div>
                </template>
                <div class="text">
                  投资人在确认受让该资产后，资金被冻结，即进入“申请中”状态，资金冻结期间投资人是不能撤销投资，申请受让前请谨慎考虑！
                </div>
              </van-collapse-item>
            </template>
          </van-collapse>
        </div>
      </div>
    </div>

    <!-- 第八部分 立即购买-->
    <div class="page-action fy" style="padding-bottom: 0.5rem">
      <div v-if="detail.scoreRate > 0" class="Obtain">
        投资本产品可获积分奖励
      </div>
      <van-button @click="onBuy" size="large" class="buy" :disabled="!canbuy">{{
        canbuy_txt
      }}</van-button>
    </div>

    <!-- 第九部分 风险测评 -->
    <van-popup class="assess-dialog" v-model="assessShow">
      <h2 class="mt-0 fs-xxl ta-c">您还没有完成风险测评</h2>
      <div class="mb-20">
        根据相关法规，买入前先进行测评，以便了解自身的风险承受能力，做出理性投资决策
      </div>
      <div class="ta-c">
        <van-button class="btn-assess" plain @click="goAssess">立即测评</van-button>
      </div>
    </van-popup>
    <!-- 风险测评是否强制显示重新测评 -->
    <van-popup class="assess-dialog" v-model="resetAssessShow">
      <h2 class="mt-0 fs-xxl ta-c">温馨提示</h2>
      <div class="mb-20">
        您好！您之前的风险测评已到期，需要重新进行风险测评，请前往测评！
      </div>
      <div class="ta-c">
        <van-button class="btn-assess" plain @click="goAssess">立即测评</van-button>
      </div>
    </van-popup>

    <!-- 第十部分 积分商城 -->
    <div v-if="
      channel &&
      ['bl', 'zn', 'tajk'].includes(channel.toLowerCase()) &&
      goods &&
      goods.length > 0
    ">
      <div class="goods-title fy">
        <span class="title-city">积分商城</span>
        <span class="title-points" @click="mypointsClick">我的积分</span>
      </div>
      <div class="goods fy">
        <div class="goods-list">
          <router-link :to="{ name: 'shop-product', params: { id: item.id } }" class="goods-list-item"
            v-for="(item, index) in goods" :key="index">
            <img :src="item.coverImg" alt />
            <div class="text">{{ item.title }}</div>
            <div class="price">市场价：{{ item.oldPriceStr }}元</div>
            <van-button class="button" size="large">
              <span>{{ item.scoreStr }}积分</span>
            </van-button>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script src="http://res.wx.qq.com/open/js/jweixin-1.6.0.js" />
<script>
import {
  Progress,
  Icon,
  Cell,
  Collapse,
  CollapseItem,
  CountDown,
  Popup,
  Toast,
  Tag,
  Tab,
  Tabs,
  Dialog
} from "vant"
import * as ProductApi from "@/api/product"
import * as ShareApi from "@/api/share"
import * as CustApi from "@/api/cust"
import moment from "moment"
import { mapGetters, mapMutations } from "vuex"
import session from "@/utils/session"
import { productIsPurchase } from "../../api/product"

export default {
  components: {
    [Progress.name]: Progress,
    [CountDown.name]: CountDown,
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [Popup.name]: Popup,
    [Tag.name]: Tag,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Toast.name]: Toast,
    [Dialog.name]: Dialog
  },

  data: () => ({
    tab: 1,
    activeName: "1",
    goods: [],
    canbuy: true,
    canbuy_txt: "立即购买",
    productId: null,
    detail: {},
    assessShow: false,
    resetAssessShow: false,
    activeNames: [],
    loading: false,
    currentTab: 1,

    share: {
      title: "", //标题
      desc: "", //描述
      imgUrl:
        "https://tianbaolian.oss-cn-shanghai-finance-1-pub.aliyuncs.com/baolian/2021120810/17b30c56-17d4-4f40-8d18-1343cf613dde.jpg",
      link: location.href.split("#")[0]
    }
  }),
  beforeRouteEnter(to, from, next) {
    let p1 = ProductApi.detail(to.query.productId)
    let p2 = ProductApi.canbuy(to.query.productId)
    Promise.all([p1, p2]).then((data) => {
      next((vm) => {
        vm.setData(data)
      })
    })
  },
  beforeRouteUpdate(to, { }, next) {
    let p1 = ProductApi.detail(to.query.productId)
    let p2 = ProductApi.canbuy(to.query.productId)
    Promise.all([p1, p2]).then((data) => {
      this.setData(data)
      next()
    })
  },
  methods: {
    changetabs: function (num) {
      this.currentTab = num
      var id = "#title" + num

      if (document.querySelector(id) != undefined) {
        document.querySelector(id).scrollIntoView(true)
      }
    },

    onCustomizedProductPreach() {
      if (this.detail.isCustomizedProduct == 1) {
        CustApi.customizedProductPreach(this.productId)
          .then((data) => {
            if (data) {
              console.log("data == %O", data)
              if (data.share && this.isWechant()) {
                this.share.title = this.detail.shareTitle
                this.share.desc = this.detail.shareDesc
                this.share.link =
                  this.share.link +
                  "#/detail?productId=" +
                  this.productId +
                  "&referrerCod=" +
                  this.userInfo.custAccount.custId +
                  "&referrerType=LINK"
                this.initShareConfig()
              }
            }
          })
          .catch((e) => {
            Toast(e.msg || e.message)
          })
      }
    },

    // 新添加 跳转我的积分
    mypointsClick() {
      this.$router.push("/pointsmall")
    },
    setData(data) {
      console.log("data == %O", data)
      this.detail = data[0]
      this.productId = this.detail.id
      
      this.canbuy_txt = this.detail.productType == 2 ? "立即委托" : this.detail.productType == 5 ? "进入竞拍" : "立即购买"

      this.canbuy_txt = this.detail.productType == 2 ? "立即委托" : "立即购买"

      if (this.detail.sold == 100 || this.detail.isFull) {
        this.canbuy = false
        this.canbuy_txt = "资产已抢光"
      }
      if (!data[1].canBuy) {
        this.canbuy = false
        this.canbuy_txt = data[1].msg || "资产已抢光"
      }
      // 3006 用户放弃签署 3007 用户和产品风险等级不匹配
      console.log("canbuy == " + data[1])
      if (this.onNormalLook()) {
        this.resetAssessShow =
          this.userInfo.userLevel > 0 ? this.userInfo.forceAssess : false
        if (data[1].code == 3006) {
          this.assessShow = this.resetAssessShow == true ? false : true
        }
      }
      this.setShare()

      if (
        !this.$route.query.isExclusive &&
        this.userInfo.isAuthName &&
        this.userInfo.isBindCard &&
        (this.userInfo.userLevel > 0 || !this.userInfo.forceAssess)
      ) {
        this.onCustomizedProductPreach()
      }
    },
    // 倒计时结束时触发
    finish() {
      this.canbuy = false
      this.canbuy_txt = "资产募集已结束"
    },

    formatPrice() {
      return "¥" + (this.detail.price / 100).toFixed(2)
    },
    isAfter(time1, time2) {
      return moment(time1).isAfter(time2, "second")
    },
    //判断是否已经完成基本信息的操作
    onNormalLook() {
      if (this.userInfo.isAuthName) {
        if (this.userInfo.userLevel < 1) {
          session.setJson("cq", {
            productId: this.productId,
            isExclusive: this.$route.query.isExclusive,
            target: "detail"
          })
          this.assessShow = this.resetAssessShow == true ? false : true
          return false
        }
        //检测绑卡
        if (!this.userInfo.isBindCard) {
          Dialog.alert({
            title: "温馨提示",
            message: "您还未绑卡，请先去绑卡？",
            confirmButtonText: "去绑卡",
            showCancelButton: true,
            theme: "round-button"
          })
            .then(() => {
              session.setJson("cq", {
                productId: this.productId,
                isExclusive: this.$route.query.isExclusive,
                target: "detail"
              })
              this.$router.push({ name: "bindcard" })
            })
            .catch(() => { })
          return false
        }
        return true
      } else {
        //未设置实名
        Dialog.alert({
          title: "温馨提示",
          message: "您还未实名，请先去实名认证？",
          confirmButtonText: "去实名",
          showCancelButton: true,
          theme: "round-button"
        })
          .then(() => {
            session.setJson("cq", {
              productId: this.productId,
              isExclusive: this.$route.query.isExclusive,
              target: "detail"
            })
            this.$router.push({ name: "realname" })
          })
          .catch(() => { })
        return false
      }
    },

    onBuy() {
      //检测测评
      //forceAssess 是否强制评测
      //assessNum 已评测次数
      // if (this.userInfo.assessNum < 1 || this.userInfo.forceAssess) {
      if (this.onNormalLook()) {
        this._showLoading()
        ProductApi.canbuy(this.detail.id)
          .then((data) => {
            this._dismissLoading()
            if (this.detail.productType == 5) {
             this.getForward()
              return
            }
            if (data.canBuy) {
              // 清除本地缓存信息
              localStorage.removeItem("payForm")
              session.del("payForm")
              if (this.detail.isProductBaseAccount === 1) {
                // 0：普通产品 1：特殊产品1 2：特殊产品2 是否限定为针对产品账户设置的产品，除了产品账户之外的余额无法购买
                this.$router.push({
                  name: "special_buying",
                  query: {
                    productId: this.productId
                  }
                })
              } else {
                if (this.detail.productType == 4) {
                  productIsPurchase()
                    .then((data) => {
                      if (data) {
                        // 体验金产品
                        this.$router.push({
                          name: "experience_buying",
                          query: {
                            productId: this.productId
                          }
                        })
                      } else {
                        this._showTipsInfo(
                          "温馨提示",
                          "您已认购过体验金资产，可至“我的理财”中查看认购的体验金资产详情",
                          "",
                          "好的",
                          () => { },
                          () => { }
                        )
                      }
                    })
                    .catch((e) => {
                      Toast(e.msg || e.message)
                    })
                } else {
                  this.$router.push({
                    name: "buying",
                    query: {
                      productId: this.productId,
                      productType: this.detail.productType
                    }
                  })
                }
              }
            } else {
              this.canbuy = false
              this.canbuy_txt = data.msg || "资产已抢光"
              Toast({
                message: data.msg || "资产已抢光"
              })
            }
          })
          .catch((e) => {
            this._dismissLoading()
            Toast(e.msg || e.message)
            // 3006 用户放弃签署 3007 用户和产品风险等级不匹配
            if (e.code == 3006) {
              this.assessShow = true
            }
          })
      }
    },
    getForward() {
        ProductApi.getForward({ custId: this.userInfo.custAccount.custId, target:'order',orderSn: this.detail.sn })
        .then((data) => {
        if (data) {
          location.href = data
          return
          this.$router.push({ name: "webview-page", query: { title: '竞拍', url: encodeURIComponent(data) } })
        }
      })
      .catch((e) => {
        Toast(e.msg || e.message)
      })
    },
    goAssess() {
      session.setJson("cq", {
        productId: this.productId,
        isExclusive: this.$route.query.isExclusive,
        target: "detail"
      })
      this.$router.push({ path: "/questions" })
    },

    goBack() {
      if (this.$route.query.share && this.$route.query.share.length > 0) {
        this.$router.push({ name: "home", query: { chanlCode: this.channel } })
      } else if (
        this.$route.query.isProductdescPush ||
        this.$route.query.referrerCod ||
        this.$route.query.referrerType
      ) {
        this.$router.push({ name: "home", query: { chanlCode: this.channel } })
      } else {
        this.goableBack()
      }
    },
    setShare() {
      if (this.detail.shareTitle && this.detail.shareTitle.length) {
        let sharepath = encodeURIComponent(
          `/detail?productId=${this.detail.id}&invite=${this.userInfo.custId}&chanlCode=${this.channel}&share=wx`
        )
        let share = {
          title: this.detail.shareTitle,
          desc: this.detail.shareDesc,
          link: `${process.env.VUE_APP_BASE_URL}?sharepath=${sharepath}`,
          invite: this.userInfo.custId
        }
        this.$emit("setShare", share)
      }
    },
    amountFormat(amount) {
      return ((amount / 10000 / 100).toFixed(2) * 100) / 100
    },

    initShareConfig() {
      let url = location.href.split("#")[0]
      ShareApi.getSignature({
        url: url
      })
        .then((data) => {
          //通过config接口注入权限验证配置  只要调后端接口就可以了。后端会把那些信息处理好，然后通过一个接口返给你这些参数
          //拼接sha1加密字符串
          if (this.isWechant()) {
            wx.config({
              // development production
              debug: process.env.NODE_ENV == "development",
              // debug: process.env.NODE_ENV != "production", // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
              timestamp: data.timestamp,
              appId: data.appid, // 必填，公众号的唯一标
              nonceStr: data.noncestr, // 必填，生成签名的时间戳
              signature: data.signature, // 必填，生成签名的随机串
              jsApiList: [
                "updateAppMessageShareData",
                "updateTimelineShareData"
              ] // 必填，需要使用的JS接口列表
            })
            //通过ready接口处理成功验证
            wx.ready(() => {
              //需在用户可能点击分享按钮前就先调用
              //分享到朋友圈"
              wx.updateTimelineShareData({
                title: this.share.title,
                link: this.share.link, // 分享链接
                imgUrl: this.share.imgUrl, // 分享图标
                success: function (res) {
                  console.log("分享朋友圈成功")
                },
                cancel: function (res) {
                  console.log("分享朋友圈失败")
                }
              })
              //分享给朋友
              wx.updateAppMessageShareData({
                title: this.share.title,
                link: this.share.link, // 分享链接
                imgUrl: this.share.imgUrl, // 分享图标
                desc: this.share.desc, // 分享描述
                success: function (res) {
                  console.log("分享好友成功")
                },
                cancel: function (res) {
                  console.log("分享好友失败")
                }
              })
            })
          }
        })
        .catch((e) => {
          this.$toast(e.msg || e.message)
        })
    },

    ...mapMutations(["setToken", "setUserInfoIsProm"])
  },

  computed: {
    ...mapGetters(["channel", "os", "token", "userInfo"]),
    characteristicArray() {
      if (this.detail.keyMap && this.detail.keyMap.length > 0) {
        const datas = this.detail.keyMap
        datas.forEach((item) => {
          if (item.type === 1) {
            if (item.val.length && item.val.length > 0) {
              var obj = new Object()
              if (item.val.indexOf("\\n") > -1) {
                obj.datas = item.val.split("\\n")
              } else {
                obj.datas = item.val.split("\n")
              }
              item.subTitle = obj.datas
            }
          }
        })
        return datas.filter((item) => item.type != 2)
      }
      return []
    },
    countDown: function () {
      if (this.detail.endTime && !this.detail.isFull) {
        let time = moment(this.detail.endTime).diff(this.detail.serverTime)
        return time
      } else {
        return 0
      }
    },
    // 过滤起投金额
    ruleItemTitles() {
      if (this.detail.keyMap) {
        return this.detail.keyMap.filter((item) => item.key !== "起投金额")
      }
      return []
    },
    miniAmount: function () {
      if (
        this.detail.raisedAmount - this.detail.currentRaise <
        this.detail.miniAmount &&
        this.detail.sold < 100
      ) {
        return (this.detail.raisedAmount - this.detail.currentRaise) / 1000000
      } else {
        return this.detail.miniAmount / 100 / 10000
      }
    },
    rateInterval: function () {
      if (this.detail.ifStair) {
        let stairRate = this.detail.stairRate
        let minRate = 10000,
          maxRate = 0
        let keys = ["One", "Two", "Three", "Four", "Five", "Six"]
        keys.forEach((k) => {
          if (stairRate["rate" + k]) {
            if (minRate > this.detail.stairRate["rate" + k]) {
              minRate = this.detail.stairRate["rate" + k]
            }
            if (maxRate < this.detail.stairRate["rate" + k]) {
              maxRate = this.detail.stairRate["rate" + k]
            }
          }
        })
        if (this.detail.hasNewYearActivity && this.detail.activityDiscount) {
          //有新年红包活动
          return {
            minRate: parseFloat(
              minRate + this.detail.activityDiscount.rate
            ).toFixed(2),
            maxRate: parseFloat(
              maxRate + this.detail.activityDiscount.rate
            ).toFixed(2)
          }
        } else {
          return { minRate: minRate, maxRate: maxRate }
        }
      }
    },
    rateInterval1: function () {
      if (this.detail.ifStair) {
        let stairRate = this.detail.pydStairRate
        let minRate = 10000,
          maxRate = 0
        let keys = ["One", "Two", "Three", "Four", "Five", "Six"]
        keys.forEach((k) => {
          if (stairRate["rate" + k]) {
            if (minRate > this.detail.pydStairRate["rate" + k]) {
              minRate = this.detail.pydStairRate["rate" + k]
            }
            if (maxRate < this.detail.pydStairRate["rate" + k]) {
              maxRate = this.detail.pydStairRate["rate" + k]
            }
          }
        })
        return { minRate: minRate, maxRate: maxRate }
      }
    },
    expectedRate: function () {
      if (this.detail.hasNewYearActivity && this.detail.activityDiscount) {
        return parseFloat(
          this.detail.expectedRate + this.detail.activityDiscount.rate
        ).toFixed(2)
      } else {
        return this.detail.expectedRate
      }
    },

    progress: function () {
      console.info(this.detail.raisedAmount, this.detail.currentRaise)
      if (this.detail.raisedAmount) {
        return parseInt(
          (this.detail.currentRaise / this.detail.raisedAmount) * 100
        )
      } else {
        return 0
      }
    },
    progressText: function () {
      // if (this.canbuy) {
      if (!this.isSoldOut) {
        if (this.detail.sold > 90) {
          return "即将售罄"
        } else if (this.detail.sold < 10) {
          return "新开抢中"
        } else {
          return ""
        }
      } else {
        // return ""
        return "已售罄"
      }
    },
    //已售罄判断
    sellout: function () {
      return this.detail.raisedAmount - this.detail.currentRaise > 0
    },
    // 判断是否已经完成，显示剩余额度判断
    isSoldOut: function () {
      return (
        this.detail.isFull ||
        this.detail.raisedAmount - this.detail.currentRaise <= 0 ||
        this.detail.serverTime > this.detail.endTime
      )
    },
    getRiskRating: function () {
      /**
       * 5低风险
       * 4中低风险
       * 3中风险
       * 2中高风险
       * 1高风险
       */
      switch (this.detail.riskRating) {
        case 1:
          return "高风险"
          break
        case 2:
          return "中高风险"
          break
        case 3:
          return "中风险"
          break
        case 4:
          return "中低风险"
          break
        case 5:
          return "低风险"
          break
        default:
          return "低风险"
          break
      }
    }
  },
  created() {
    setTimeout(() => {
      if (this.$route.query.isExclusive) {
        wx.hideAllNonBaseMenuItem()
      }
    }, 1000)
  },
  destroyed() {
    wx.showAllNonBaseMenuItem()
  }
}
</script>

<style lang="less" scoped>
.blank {
  display: none;
}

.demo {
  position: absolute;
  top: -20px;
  left: 0;
  width: 100%;
  z-index: 10000;
  opacity: 0.5;

  img {
    width: 100%;
  }
}

.page-container {
  background: #f1f5f8;
}

.detail {
  // -----------------------------------------------------------

  // 1 header
  .header {
    background-image: url(../../assets/img/detail/bjt.jpg);
    background-size: 100% 100%;
    background-repeat: no-repeat;
    overflow: hidden;
    padding: 20px 14px;

    // 募集倒计时 top
    .top {
      height: 20px;
      display: flex;
      justify-content: center;

      .top-son {
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 50px;
        background-color: #fea277;
        padding: 3px 14px;
        letter-spacing: 1px;

        .title {
          font-size: 13px;
          color: #c84608;
          // font-weight: 700;
        }
      }
    }

    // 收益率/期限/剩余额度
    .center {
      margin-top: 20px;
      display: flex;
      align-items: center;
      justify-items: center;

      // 左
      .center-left {
        flex: 1;
        text-align: center;

        .left-t {
          b {
            font-size: 20px;
            color: #ffffff;
          }

          span {
            margin-left: 1px;
            color: #ffffff;
          }

          .c {
            margin: 0 3px;
          }
        }

        .left-d {
          opacity: 0.64;
          font-size: 12px;
          color: #ffffff;
          margin-top: 5px;
        }

        .left {
          margin-top: 10px;

          .down-l {
            border-radius: 5px;
            letter-spacing: 0.3px;
            font-size: 10px;
            padding: 3px 4px;
          }
        }
      }

      // 中
      .center-center {
        flex: 1;
        text-align: center;

        .center-t {
          b {
            font-size: 20px;
            color: #ffffff;
          }

          span {
            margin-left: 1px;
            color: #ffffff;
          }
        }

        .center-d {
          font-size: 12px;
          color: #ffffff;
          opacity: 0.64;
          margin-top: 5px;
        }

        .center-tag {
          margin-top: 10px;

          .down-c {
            padding: 3px 4px;
            border-radius: 5px;
            border: none !important;
            letter-spacing: 0.3px;
          }
        }
      }

      // 右
      .center-right {
        flex: 1;
        text-align: center;

        .right-t {
          b {
            font-size: 20px;
            color: #ffffff;
          }

          span {
            color: #ffffff;
            margin-left: 1px;
          }
        }

        .right-d {
          font-size: 12px;
          color: #ffffff;
          opacity: 0.64;
          margin-top: 5px;
        }

        .right {
          margin-top: 10px;

          .down-r {
            padding: 3px 4px;
            border-radius: 5px;
            border: none !important;
            letter-spacing: 0.3px;
          }
        }
      }
    }
  }

  // 2 rule
  .rule {
    //  height: 255px;
    margin: 15px 14px 0 14px;
    background-color: #fff;
    border-radius: 5px;

    .rule-box {
      margin: 0 18px;
      padding-bottom: 15px;

      .rule-title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 18px 0 15px 0;

        .title-a {
          font-size: 17px;
          font-weight: 700;
          color: #333333;
        }

        .title-b {
          font-size: 14px;
          color: #404040;
        }
      }

      table.rule-main {
        overflow: hidden;
        width: 100%;
        border-radius: 3px;
        border-collapse: collapse;
        border-spacing: 0;

        td,
        th {
          border: 1px solid #ebeaea;
          vertical-align: center;
          text-align: center;
          line-height: 39px;
        }

        td:first-child,
        th:first-child {
          width: 50%;
          border-right: none;
        }

        td:last-child,
        th:last-child {
          border-left: none;
        }

        thead {
          background-color: #fff0ea;

          th {
            font-size: 14px;
            font-weight: 700;
            color: #fd7127;
          }
        }
      }

      // des
      .rule-des {
        height: 60px;
        display: flex;
        align-items: center;

        .des {
          font-size: 12px;
          color: #666666;
          letter-spacing: 1px;
        }
      }
    }
  }

  // 3 time
  .time {
    margin: 15px 14px 0 14px;
    border-radius: 5px;
    background-color: #fff;

    .time-box {
      margin: 0 18px;

      // top
      .top {
        display: flex;
        align-items: center;
        padding: 16px 0;

        .r {
          flex: 1;
          display: flex;
          justify-content: center;
          align-items: center;
          // border: 1px solid #000000;

          img {
            width: 22px;
          }
        }

        .top-left {
          flex: 2;

          // border: 1px solid #000000;
          .a {
            font-size: 14px;
            color: #404040;
            text-align: center;
          }

          .b {
            font-size: 12px;
            color: #999999;
            text-align: center;
          }

          .img {
            height: 39px;
            width: 39px;
            background-color: #fff0ea;
            border-radius: 50px;
            text-align: center;
            margin: 12px auto;
            // margin-left: 9px;

            display: flex;
            justify-content: center;
            align-items: center;

            img {
              width: 36px;
              height: 36px;
            }
          }
        }
      }

      // center
      .center {
        height: 55px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-top: 1px solid #ebeaea;

        .left {
          font-size: 14px;
          color: #999999;
        }

        .right {
          font-size: 14px;
          color: #333333;
        }
      }
    }
  }

  // 4 nav
  // .nav {
  //   margin: 16px 14px 27px 14px;
  //   background-color: #ffffff;
  //   border-radius: 5px;

  //   .van-tabs {
  //   }
  //   .nav-box {
  //     display: flex;
  //     border-radius: 5px;

  //     div {
  //       flex: 1;
  //       height: 40px;
  //       text-align: center;
  //       line-height: 40px;

  //       span {
  //         font-size: 16px;
  //         color: #d6ae73;
  //         font-weight: 700;
  //       }
  //     }
  //   }
  // }
  // .active {
  //   background-color: #d6ae73;
  //   border-radius: 5px;
  //   span {
  //     color: #ffffff !important;
  //   }
  // }

  // 5 trait
  .trait {
    margin: 0 14px;

    #title1 {
      font-size: 16px;
      color: #333333;
      font-weight: 700;
      margin-top: 15px;
      margin-bottom: 10px;
    }

    .trait-box {
      padding: 16px 19px;
      background-color: #fff;
      border-radius: 5px;

      .box-title {
        margin-top: 20px;
        font-size: 14px;
        color: #fc6524;
      }

      :first-child .box-title {
        margin-top: 0;
      }

      .center {
        padding-top: 12px;

        .center-box {

          // border: 1px solid #000;
          img {
            width: 14px;
            height: 14px;
          }

          span {
            margin-left: 8px;
            font-size: 14px;
            color: #797979;
          }
        }
      }

      img {
        width: 100%;
        height: 138px;
        vertical-align: middle;
      }
    }
  }

  // 6 file
  .file {
    margin: 0 14px;

    #title2 {
      font-size: 16px;
      color: #333333;
      font-weight: 700;
      margin-top: 15px;
      margin-bottom: 10px;
    }

    .file-box {
      background-color: white;
      border-radius: 6px !important;

      .van-cell {
        background-color: transparent;
      }
    }
  }

  // 7 problem
  .problem {
    margin: 0 14px;
    border-radius: 5px;

    #title3 {
      font-size: 16px;
      color: #333333;
      font-weight: 700;
      margin-top: 15px;
      margin-bottom: 10px;
    }

    .problem-box {
      padding: 16px 19px;
      background-color: #fff;
      border-radius: 5px;

      .van-hairline--top-bottom:after {
        border: none;
      }

      .first {
        font-size: 13px;
        color: #333333;
        font-weight: 700;
        letter-spacing: 0.5px;
        display: flex;
        padding: 5px 0;

        img {
          width: 14px;
          height: 14px;
          margin: 6px 8px 0 0;
        }
      }

      .text {
        padding: 10px 24px;
        padding-top: 0px;
        font-size: 12px;
        color: #828282;
        letter-spacing: 0.5px;
      }
    }
  }

  .box:first-child {
    // padding-top: 15px;
    margin-top: 0;
  }

  .count-down {
    font-size: 16px;
    text-align: left;

    img {
      margin-right: 10px;
      position: relative;
      height: 24px;
      color: @red;
      top: 5px;
    }

    .van-count-down {
      font-size: 16px;
      margin-left: 10px;
      color: #c7a673;
      display: inline-block;
    }
  }

  .info {
    justify-content: space-around;

    .item {
      box-sizing: border-box;

      &.rate {
        width: 50%;
      }

      &.duration {
        width: 50%;
      }
    }
  }

  .info2 {
    border-right: 0;
    border-left: 0;
    border-bottom: 0;
    display: flex;
    justify-content: space-between;
    align-items: stretch;
    border-top: 1px solid;
    padding: 10px 0 8px 0;
    line-height: 32px;
    background: #fff;
    border-color: #c1a76a;
    border-image: linear-gradient(to left, #c1a76a, #f4e1b0, #c1a76a) 1;
  }

  .progress {
    margin-top: 5px;
    width: 70px;
    height: 3px;
    background-color: #f2f2f2;
    border-radius: 3px;
    position: relative;
    border: 1px solid transparent;

    .progress-pivot {
      box-sizing: border-box;
      height: 100%;
      background-color: @golden;
      border-radius: 3px;
    }

    .text {
      position: absolute;
      height: 100%;
      width: 100%;
      text-align: center;
      top: 0;
      left: 0;
      //background-image: linear-gradient(to right,#fff 0%, #fff 72% ,#DF4744 72%,#DF4744 100%);
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }

  .feature {
    video {
      width: 100%;
      border-radius: 10px;
    }

    a {
      color: @dark;
    }
  }

  .time-line {
    .steps {
      display: flex;

      .item {
        width: 33.3%;

        .title {
          box-sizing: border-box;
          height: 30px;
          vertical-align: bottom;
        }

        .line {
          margin: 15px 0 5px;
          position: relative;
          width: 100%;
          height: 1px;
          background-color: @red;

          .circle {
            position: absolute;
            left: 50%;
            top: 0;
            width: 5px;
            height: 5px;
            border: 1px solid @red;
            border-radius: 50%;
            transform: translate(-50%, -50%);
            background: #fff;
          }
        }
      }

      .item.fill {
        .line .circle {
          background: @red;
        }
      }

      .item:first-child {
        .title {
          padding-top: 16px;
        }

        .line .circle {
          left: 0;
          right: auto;
          transform: translate(0, -50%);
        }
      }

      .item:last-child {
        .title {
          padding-top: 16px;
        }

        .line .circle {
          left: auto;
          right: 0;
          transform: translate(0, -50%) !important;
        }
      }
    }

    table {
      border-collapse: separate;
      border-spacing: 5px 0;
      font-size: 12px;
      width: 100%;

      td {
        vertical-align: top;
      }

      tr.text td {
        padding: 2px;
      }

      tr.scale td {
        border-left: 1px solid @gray;
      }

      tr.scale td:last-child {
        border-left: 1px solid @golden;
        border-right: 1px solid @golden;
      }

      tr.graph td {
        padding: 3px;
      }

      tr.graph td:nth-child(1) {
        background: url("/img/detail/bg-1.png") repeat-x;
        background-size: auto 100%;
      }

      tr.graph td:last-child {
        border: 1px solid @golden;
        background: #f9f7f3;
      }
    }
  }

  .record {
    ::v-deep .van-cell {
      padding: 5px 0;

      &:not(:last-child)::after {
        border: none;
      }
    }

    ::v-deep .van-collapse-item .van-collapse-item__content {
      padding-top: 0;
    }

    .van-hairline--top-bottom::after {
      border: none;
    }
  }

  .qa {
    .tag {
      font-size: 10px;
      width: 14px;
      height: 14px;
      line-height: 14px;
      text-align: center;
      margin-right: 10px;
      color: @white;
      border: 1px solid @white;
    }

    .text {
      font-size: 12px;
      flex: 1;
    }

    .q .tag {
      background-color: @golden;
      border: 1px solid @golden;
    }

    .a .tag {
      color: @golden;
      background-color: @white;
      border: 1px solid @golden;
    }

    .a .text {
      color: @gray-dark;
    }
  }
}

.assess-dialog {
  padding: 0.8rem;
  width: 70vw;

  .btn-assess {
    width: 70%;
    color: @golden;
    font-size: @font-size-xxl;
    border-color: @golden;
    border-radius: 5px;
  }
}

//兑换列表
.goods {
  margin: 13px;
  border-radius: 8px;
  background-color: #ffffff;

  .goods-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 27px 25px;

    .goods-list-item {
      width: 130px;

      img {
        width: 130px;
        height: 130px;
      }

      .text {
        height: 35px;
        font-size: 12px;
        font-weight: 700;
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }

      .price {
        color: #7b7a7a;
        font-size: 10px;
        margin-top: 10px;
        margin-bottom: 10px;
        text-decoration: line-through;
      }

      .button {
        height: 26px;
        width: 130px;
        font-size: 12px;
        background-color: #fc6524;
        color: #ffffff;
        border: none;
        border-radius: 2px;
      }
    }
  }
}

.goods-title {
  height: 30px;
  line-height: 30px;
  margin: 0 13px;
  display: flex;
  justify-content: space-between;

  font-size: 16px;
  color: #333333;
  font-weight: 700;
  margin-top: 27px;
  margin-bottom: 10px;

  .title-city {
    font-size: 16px;
    font-weight: 700;
  }

  .title-points {
    font-size: 12px;
    color: #999999;
  }
}

//
.Obtain {
  font-size: 14px;
  background-color: #f1f5f8;
  text-align: center;
  color: #333333;
  letter-spacing: 0.5px;
}

.buy {
  background-color: #d6ae73;
  color: #ffffff;

  &.van-button--disabled {
    background-color: #d1d1d3;
    color: #ffffff;
    opacity: 1;
  }
}
</style>